import * as moment from 'moment';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import * as fromStore from '../store';
import * as fromCompanySettingsStore from '../../settings/store';
import { Account } from '../model/account';
import { AccountInvoice } from '../model/account-invoice';
import { AccountInvoicesService } from '../services/account-invoices.service';
import { User } from '../../user-management/users/user';
import { WindowService } from '../../shared/browser/window.service';
import { filter, map } from 'rxjs/operators';
import { CompanySettings } from '../../settings/model/company-settings';
import { AccountType } from '../account-types.enum';

@Component({
  selector: 'ls-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountComponent implements OnInit {
  public account$: Observable<Account>;
  public user$: Observable<User>;
  public accountInvoices$: Observable<Array<AccountInvoice>>;
  public hasManagerAccess$: Observable<boolean>;
  public companySettings$: Observable<CompanySettings>;
  public showPastDueBanner: boolean;
  public account: Account;

  public now: moment.Moment = moment();

  constructor(
    private store: Store<fromStore.AccountState>,
    private accountInvoiceService: AccountInvoicesService,
    private windowService: WindowService,
    private CompanySettingsStore: Store<fromCompanySettingsStore.CompanyState>
  ) {}

  public ngOnInit(): void {
    this.account$ = this.store
      .select(fromStore.getAccountInformation)
      .pipe(filter((account: Account) => !!account));
    this.account$.subscribe((account: Account) => {
      this.account = account;
      this.showPastDueBanner = this.shouldShowPastDueBanner();
    });

    this.hasManagerAccess$ = this.store
      .select(fromStore.getHasManagerAccess)
      .pipe(filter((access: boolean) => !!access));
    this.user$ = this.store
      .select(fromStore.getUserInformation)
      .pipe(filter((user: User) => !!user));
    this.accountInvoices$ = this.store
      .select(fromStore.getAccountInvoices)
      .pipe(filter((invoices: Array<AccountInvoice>) => !!invoices));
    this.companySettings$ = this.CompanySettingsStore.select(
      fromCompanySettingsStore.getCompanySettings
    ).pipe(filter((companySettings: CompanySettings) => !!companySettings));

    this.showPastDueBanner = this.shouldShowPastDueBanner();
  }

  private shouldShowPastDueBanner(): boolean {
    if (!this.account) {
      return false;
    }

    return (
      this.account &&
      (this.account.pastDue || this.account.type === AccountType.SUSPENDED)
    );
  }

  public requestPaymentUrl(invoice: AccountInvoice): void {
    this.accountInvoiceService.requestAccountInvoiceUrl(invoice).pipe(
      map((url: string) => {
        if (url) {
          this.windowService.open(url);
        }
      })
    );
  }
}
